module.exports = __webpack_public_path__ + "media/src/assets/Images/OurHistoryBackground-a2dcf5db6d3968da18b1102f9ac5c6b2.svg";